import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"
import _imports_0 from '../../../../assets/aw-footer-logo.jpg'


const _hoisted_1 = { class: "report-template" }
const _hoisted_2 = {
  key: 0,
  class: "section"
}
const _hoisted_3 = {
  key: 1,
  class: "report-chart"
}
const _hoisted_4 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Watermark = _resolveComponent("Watermark")!
  const _component_PotEffectChart = _resolveComponent("PotEffectChart")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Watermark, { isSampleReport: _ctx.isSampleReport }, null, 8, ["isSampleReport"]),
    _createVNode(_component_v_card, {
      class: "report-page-card",
      outlined: "",
      flat: ""
    }, {
      default: _withCtx(() => [
        (_ctx.filters.ePotSize)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[0] || (_cache[0] = [
              _createElementVNode("div", { class: "section-title" }, [
                _createElementVNode("div", { class: "section-badge" }),
                _createTextVNode(" Effect of Pot Size ")
              ], -1),
              _createElementVNode("div", { class: "section-content" }, [
                _createTextVNode(" The following graph highlights the effect of pot size on AgeWage scores. The pot size has been segmented as per "),
                _createElementVNode("a", {
                  href: "https://www.fca.org.uk/data/retirement-income-market-data",
                  class: "text-primary",
                  target: "_blank"
                }, "FCA Retirement Income analysis"),
                _createTextVNode(". Please note that the pot sizes are at different stages of life cycle and developed over different time frames. However, the AgeWage score represents a fair estimation of the effects of charges, fund returns and contribution frequency on the performance of the pots relative to the benchmark. ")
              ], -1)
            ]))]))
          : _createCommentVNode("", true),
        (!_ctx.fetchingChartData && _ctx.filters.ePotSize)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_ctx.ePotData)
                ? (_openBlock(), _createBlock(_component_PotEffectChart, {
                    key: 0,
                    chartData: _ctx.ePotData,
                    plotterColor: _ctx.plotterColor,
                    provider: _ctx.filters.provider,
                    priceTrack: _ctx.filters.priceTrackObject,
                    isSampleReport: _ctx.isSampleReport,
                    reportfilterRanges: _ctx.reportfilterRanges
                  }, null, 8, ["chartData", "plotterColor", "provider", "priceTrack", "isSampleReport", "reportfilterRanges"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("div", null, null, -1)),
          _createVNode(_component_v_img, {
            class: "footer-img",
            src: _imports_0
          })
        ])
      ]),
      _: 1
    })
  ]))
}